import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const InfoCardNewsContainer = styled.div`
  max-width: 100%;
  margin: 0 auto;
  padding: 5% 15% 5% 15%;

  @media (max-width: 500px) {
    padding: 5%;
  }
`;

const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

const SectionTitle = styled.h2`
  color: #FFFFFF;
  font-weight: 700;
  font-size: 36px;
  line-height: 52px;
  letter-spacing: 0.05em;
  border-left: 8px solid #FFF56A;
  padding: 0% 0% 0% 2.5%;

  @media (max-width: 500px) {
    font-size: 32px;
  }
`;

const ArrowButton = styled.button`
  background-color: #000000;
  color: #FFFFFF;
  padding: 10px;
  cursor: pointer;
  margin: 1px;
  border: 1px solid rgba(255, 255, 255, 0.6);
  border-radius: 50%;
  width: 40px;
  height: 40px;
  font-size: 18px;

  &:hover {
    background-color: #FFFFFF;
    color: #000000;
  }

  @media (max-width: 500px) {
    font-size: 16px;
    padding: 0px;
    margin: 0px;
    width: 30px;
    height: 30px;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 24px; 

  @media (max-width: 500px) {
    gap: 12px;
  }
`;

const CardCarousel = styled.div`
  display: flex;
  overflow: hidden;
  width: 100%;

`;

const Card = styled.div`
  background: #1f1f1f;
  border-radius: 30px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 2.5%;
  gap: 18px;
  color: #ffffff;
  margin-right:3%;
  flex: 0 0 calc(43%);

  p {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #afafaf;
    margin-top: 0px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }

  h3 {
    font-style: normal;
    font-weight: 500;
    font-size: 28px;
    line-height: 41px;
    color: #ffffff;
    margin-bottom: 0px;
    margin-top: 5px;
  }

  &:last-child {
     margin-right: 0; /* 最後一個卡片沒有右邊距 */
  }

  @media (max-width: 500px) {
    width: 100%;
    gap: 9px;
    flex: 0 0 calc(80%); /* 設定原本的寬度和間距 */
    margin-right:3%;
    padding:5%;

    h3 {
      font-size: 18px;
      line-height: 26px;
    }

    p {
      font-size: 14px;
      line-height: 22px;
    }
  }
`;


const ReadMoreButton = styled.button`
  background-color: transparent;
  color: #ffffff;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 26px;
  letter-spacing: 0.05em;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 40px;
  box-sizing: border-box;
  border: 1px solid rgba(255, 255, 255, 0.6);
  border-radius: 100px;
  cursor: pointer;
  margin-left: auto;

  @media (max-width: 500px) {
    font-size: 14px;
    line-height: 24px;

    padding: 6px 20px;

    margin: 0 0 5% auto;
  }

  &:hover {
    background-color: #ffffff;
    color: #1f1f1f;
  }
`;

const InfoCardNews = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const cardArray = [0, 1, 2, 3, 4, 5,6]; 

  const handlePrev = () => {
    setCurrentIndex((prevIndex) => Math.max(0, prevIndex - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) => Math.min(prevIndex + 1, cardArray.length - 1));
  };

  const [news, setNews] = useState([])

  const fetchNewsData = () => {
    fetch(`${process.env.REACT_APP_ADMIN_URL}/api/news`)
      .then(response => {
        return response.json()
      })
      .then(data => {
        setNews(data)
      })
  }

  useEffect(() => {
    fetchNewsData()
  }, [])

  return (
    <InfoCardNewsContainer>
      <SectionHeader>
        <SectionTitle>最新消息</SectionTitle>
        <ButtonContainer>
          <ArrowButton onClick={handlePrev}>&#060;</ArrowButton>
          <ArrowButton onClick={handleNext}>&#062;</ArrowButton>
        </ButtonContainer>
      </SectionHeader>
      <CardCarousel>
        {news.slice(currentIndex, currentIndex + 2).map((item, index) => (
          <Card key={index}>
            <h3>{item.title}</h3>
            <p>{item.excerpt}</p>
            <ReadMoreButton onClick={() => window.location.href = `/newstitleanddate/?id=${item.id}`}>閱讀全文</ReadMoreButton>
          </Card>
        ))}
      </CardCarousel>
    </InfoCardNewsContainer>
  );
};

export default InfoCardNews;

